import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Button from '../../components/Button';
import { Capacitor } from '@capacitor/core';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
  background: ${(props) => props.theme.background.primary};
  color: ${(props) => props.theme.text.regular};
`;

const Content = styled.div`
  max-width: 500px;
  width: 100%;
`;

const IconContainer = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: ${(props) => props.theme.background.secondary};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 2rem;
  font-size: 2rem;
`;

const Title = styled.h1`
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: ${(props) => props.theme.text.title};
`;

const Description = styled.p`
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 2rem;
  color: ${(props) => props.theme.text.regular};
  opacity: 0.8;
`;

const UpdateRequired = () => {
  const { t } = useTranslation();
  const handleUpdate = async () => {
    try {
      const platform = Capacitor.getPlatform();
      if (platform === 'ios') {
        window.open(
          'https://apps.apple.com/us/app/deks-xyz/id6749857801',
          '_blank',
        );
      } else if (platform === 'android') {
        window.open(
          'https://play.google.com/store/apps/details?id=xyz.deks.app',
          '_blank',
        );
      }
    } catch (error) {
      console.error('Error getting device info:', error);
    }
  };

  return (
    <Container>
      <Content>
        <IconContainer>📱</IconContainer>

        <Title>{t('updateRequired.title')}</Title>

        <Description>
          {t('updateRequired.description')}
        </Description>

        <Button fullWidth onClick={handleUpdate}>
          UPDATE NOW
        </Button>
      </Content>
    </Container>
  );
};

export default UpdateRequired;
